import $ from 'jquery';
import Api from '../utilities/Api';
import Popup from '../utilities/Popup';

$('body').on('click', '.personal-toggle', function () {
    const toggle = $(this);
    toggle.toggleClass('personal-toggle--opened');
});

$('body').on('submit', '.personal-edit', function (e) {
    e.preventDefault();
    const data = $(this).serializeArray().reduce((result, item) => {
        const newResult = { ...result };
        newResult[item.name] = item.value;
        return newResult;
    }, {});

    $(this).find('input[type=file]').each(function () {
        const fileName = $(this).attr('name');
        const fileArray = $(this).prop('files')[0];
        data[fileName] = fileArray;
    });

    return Api.post('/api/user/update/', data).then((response) => {
        if (response.status === 'success') {
            window.location.reload();
        } else {
            Popup.notify('При обновлении произошла ошибка');
        }
    });
});


$('.user-sms-auth').submit(function (e) {
    e.preventDefault();
    const data = {
        uf_sms_auth: $('.control--sms-auth-checkbox input').prop('checked') ? 1 : 0
    };

    return Api.post('/api/user/sms-auth-update/', data);
});
